export function formatClass5ServiceText(Class5ServiceText: string): string {
  return Class5ServiceText.replace(/Road Test/gi, '').trim();
}
